
import pageMeta from '~/mixins/pageMeta.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteFnMixins from '~/mixins/eventTrackingFamilySiteFnMixins.js';

export default {
    name: "HappyKidsInsurer",

    mixins: [pageMeta, eventTrackingMixins, eventTrackingFamilySiteFnMixins],
    props: {
        happyKidsInsurer: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
          languages: [],
          windowWidth: 0,
        };
    },

    computed: {
        pageData() {
            return this.happyKidsInsurer;
        },
        anotherLanguage() {
            const d = this.languages.find(item => {
                return item &&
                item?.LangCode &&
                item?.LangCode !== '' &&
                item?.LangCode.toLowerCase() !== this.pageData?.Language?.LangCode.toLowerCase()
            })
            return d
        }
    },

    mounted() {
        this.updateScreenWidth();
        this.onScreenResize();
    },
    methods: {
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
        },
        updateScreenWidth() {
            this.windowWidth = window.innerWidth;
        },
        /**
         * @return {string[]}
         * @description set section style based on data from CMS.
         */
        sectionStyle(layoutStyle) {
          if ( !layoutStyle ) return;

          const style = []
          if (layoutStyle?.DisableMinHeight) {
              style.push({'min-height': 'auto'})
          }
          if (layoutStyle?.PaddingTopInPx && layoutStyle?.PaddingTopInPx >= 0 ) {
              style.push({'padding-top': `${layoutStyle?.PaddingTopInPx}px`})
          }
          if (layoutStyle?.PaddingBottomInPx && layoutStyle?.PaddingBottomInPx >= 0 ) {
              style.push({'padding-bottom': `${layoutStyle?.PaddingBottomInPx}px`})
          }
          return style
        },
        isSCCode(code) {
            return code?.toLowerCase()  === 'sc'
        },
    },

}
